'use strict';

export {
	default as AuditSalaryPayrollReportTable
} from './AuditSalaryPayrollReportTable';
export {
	default as AuditSalaryPayrollReportWorkplaceTable
} from './AuditSalaryPayrollReportWorkplaceTable';
